import { memo } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { usePromotionTags } from "../../../../../../hooks/usePromotionTags";
import { reviewTokens } from "../../../theme";
import { resolvePromotionTagNames } from "./promotionTagDisplay";

export interface PromotionTagValueProps {
  value: unknown;
}

export const PromotionTagValue = memo(function PromotionTagValue({
  value,
}: PromotionTagValueProps) {
  const { promotionTags } = usePromotionTags();
  const names = resolvePromotionTagNames(value, promotionTags);

  if (names.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{ fontSize: 13, fontStyle: "italic", color: reviewTokens.slate500 }}
      >
        No tags
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {names.map((name, i) => (
        <Chip
          key={`${name}-${i}`}
          size="small"
          label={name}
          sx={{ height: 22, maxWidth: "100%" }}
        />
      ))}
    </Box>
  );
});
